import {
  Alert,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableGroupHeader,
  TableHead,
  TableRow,
  Typography,
} from '@cmg/design-system';
import { FormattedNumber } from '@cmg/i18n';
import React from 'react';

export type ManagerEconomicsBreakdown = { firmName: string; value: number };

export type Props = Readonly<{ managerEconomicsBreakdown: ManagerEconomicsBreakdown[] }>;

const UnderwritingCommitmentDetails: React.FC<Props> = ({ managerEconomicsBreakdown }) => {
  return (
    <Stack gap={1}>
      <Typography variant="h4" py={1}>
        Underwriting Commitments
      </Typography>
      <Alert>Underwriting commitments data is subject to change.</Alert>
      <Table size="medium">
        <TableHead>
          <TableRow>
            <TableCell>Manager</TableCell>
            <TableCell align="right">UW Commitments</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableGroupHeader>
            <TableCell />
            <TableCell align="right">
              <FormattedNumber value={1} format="percent" />
            </TableCell>
          </TableGroupHeader>
          {managerEconomicsBreakdown.map(({ firmName, value }) => (
            <TableRow key={firmName}>
              <TableCell size="medium">{firmName}</TableCell>
              <TableCell size="medium" align="right">
                <FormattedNumber value={value} format="percent" />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Stack>
  );
};

export default UnderwritingCommitmentDetails;
